import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormControl,
  Validators,
  FormGroup,
} from '@angular/forms';
import { ClientService, GetClientQuery } from '../invoices/services/client.service';
import { Auth } from 'aws-amplify';
import { ValidatorFn, AbstractControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ClientModel } from '../models/client.model';
import { ProfileForm } from '../models/createProfile.model';
import { TF } from 'src/app/API.service';
import { log } from 'console';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  encapsulation: ViewEncapsulation.None, // Add this line to disable encapsulation
})
export class ProfileComponent implements OnInit {
  createProfile!: ProfileForm;
  user!: ClientModel;
  hide1: boolean = false;
  hide2: boolean = false;
  hide3: boolean = false;
  errorMessage: string = '';
  isSubmitLoading: boolean = false;
  formSubmitted = false;
  vatIncluded: boolean = false;
  isUsernameReadOnly: boolean = true;
  originalVatIncludedValue: boolean = false;
  originalFormValue: any;
  isButtonValid: boolean = false;

  loading: boolean = false;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private clientService: ClientService,
    private snackbar: MatSnackBar,
    private cdRef: ChangeDetectorRef
  ) {
    this.createProfile = this.formBuilder.group(
      {
        firstName: [
          null,
          Validators.compose([
            Validators.maxLength(30),
            Validators.minLength(1),
            Validators.required,
          ]),
        ],
        lastName: [
          null,
          Validators.compose([
            Validators.maxLength(30),
            Validators.minLength(1),
            Validators.required,
          ]),
        ],
        company: [null, Validators.required],
        email: [
          { value: '', disabled: true },
          [
            Validators.required,
            Validators.pattern(
              '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'
            ),
          ],
        ],
        oldpassword: new FormControl(''),
        confirm: new FormControl(''),
        newpassword: new FormControl(''),
        phone: [null, Validators.required],
        vatIncluded: new FormControl(false),
      },
      {
        validator: (formGroup: FormGroup) => {
          const oldpassword = formGroup.controls['oldpassword'];
          const confirm = formGroup.controls['confirm'];
          const newpassword = formGroup.controls['newpassword'];

          // Check if all three fields are empty
          if (!oldpassword.value && !newpassword.value && !confirm.value) {
            return null; // Validation successful, no need to proceed with other checks
          }

          if (
            (oldpassword.dirty || newpassword.dirty || confirm.dirty) &&
            (!oldpassword.value || !newpassword.value || !confirm.value)
          ) {
            return { required: true };
          }

          if (
            newpassword.dirty &&
            confirm.dirty &&
            newpassword?.value !== confirm?.value &&
            (confirm?.value?.length === newpassword?.value?.length ||
              confirm?.value?.length > newpassword?.value?.length)
          ) {
            return { mismatch: true };
          }

          return null;
        },
      }
    ) as ProfileForm;
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    await Auth.currentUserInfo().then(async (data) => {
      const clientData = await this.clientService.GetClient(data.attributes.sub);
    this.user = this.mapGetClientQueryToClientModel(clientData);
      if (this.user.firstName !== undefined) {
        this.createProfile.controls['firstName'].setValue(this.user.firstName);
      }
      if (this.user.lastName !== undefined) {
        this.createProfile.controls['lastName'].setValue(this.user.lastName);
      }
      this.createProfile.controls['phone'].setValue(this.user.phone);
      this.createProfile.controls['email'].setValue(this.user.email);
      this.createProfile.controls['company'].setValue(this.user.company);
      this.createProfile.controls['oldpassword'].setValue('');
      if (this.user?.isVatIncluded && this.user?.isVatIncluded == 'TRUE') {
        this.createProfile.controls['vatIncluded'].setValue(true);
      } else {
        this.createProfile.controls['vatIncluded'].setValue(false);
      }
      this.originalVatIncludedValue =
        this.createProfile.get('vatIncluded')?.value;
      this.originalFormValue = this.createProfile.value;
      this.loading = false;
    });
  }

   mapGetClientQueryToClientModel(query: GetClientQuery): ClientModel {
    return {
      __typename: query.__typename,
      id: query.id,
      address: query.address,
      city: query.city,
      company: query.company,
      createdAt: query.createdAt,
      email: query.email,
      folders: query.folders,
      phone: query.phone,
      updatedAt: query.updatedAt,
      username: query.username,
      firstName: query.firstName,
      lastName: query.lastName,
      isVatIncluded: query.isVatIncluded === 'TRUE' ? 'TRUE' : 'FALSE'
    };
  }

  
  

  isPasswordMismatch(): boolean {
    const formGroup = this.createProfile as FormGroup;
    const oldpassword = formGroup.controls['oldpassword'];
    const newpassword = formGroup.controls['newpassword'];
    const confirm = formGroup.controls['confirm'];
    return (
      (oldpassword.dirty || newpassword.dirty || confirm.dirty) &&
      confirm.value.length > 5 &&
      newpassword.value !== confirm.value
    );
  }

  inputChanged(e: any) {
    const formGroup = this.createProfile as FormGroup;
    const confirmPasswordControl = formGroup.controls['confirm'];
    const newPasswordControl = formGroup.controls['newpassword'];

    if (formGroup.hasError('mismatch')) {
      newPasswordControl.setErrors({ mismatch: true });
      confirmPasswordControl.setErrors({ mismatch: true });
    } else {
      newPasswordControl.setErrors(null);
      confirmPasswordControl.setErrors(null);
    }
    formGroup.updateValueAndValidity();

    this.formSubmitted = false;
  }

  account_validation_messages = {
    username: [
      { type: 'required', message: 'Username is required' },
      {
        type: 'minlength',
        message: 'Username must be at least 4 characters long',
      },
      {
        type: 'maxlength',
        message: 'Username cannot be more than 25 characters long',
      },
      {
        type: 'validUsername',
        message: 'Your username has already been taken',
      },
    ],
    company: [{ type: 'required', message: 'Company is required' }],
    email: [
      { type: 'required', message: 'Email is required' },
      { type: 'pattern', message: 'Enter a valid email' },
    ],
    address: [{ type: 'required', message: 'Address is required' }],
    city: [{ type: 'required', message: 'City is required' }],
    phone: [{ type: 'required', message: 'Phone Number is required' }],
  };
  passwordMatchValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const password = control.get('newpassword')!.value;
      const confirmPassword = control.get('confirm')!.value;
      return password === confirmPassword ? null : { matchPasswords: true };
    };
  }

  save() {
    console.log('save');

    if (
      this.createProfile.controls['newpassword'].value !==
      this.createProfile.controls['confirm'].value
    ) {
      this.errorMessage = 'Passwords do not match';
      return;
    }

    this.loading = true;
    this.isSubmitLoading = true;
    const isVatIncludedValue = this.createProfile.controls['vatIncluded'].value;

    const updatingClient = {
      id: this.user.id,
      firstName: this.createProfile.controls['firstName'].value.trim(),
      lastName: this.createProfile.controls['lastName'].value.trim(),
      company: this.createProfile.controls['company'].value.trim(),
      phone: this.createProfile.controls['phone'].value,
      email: this.createProfile.controls['email'].value.trim(),
      isVatIncluded: isVatIncludedValue ? TF.TRUE : TF.FALSE,
    };

    this.clientService
      .UpdateClient(updatingClient)
      .then(async () => {
        this.originalVatIncludedValue = isVatIncludedValue;
        this.originalFormValue = this.createProfile.value;
        this.formSubmitted = true;
        localStorage.setItem(
          'userInfo',
          JSON.stringify({
            phone: this.createProfile.controls['phone'].value,
            email: this.createProfile.controls['email'].value,
            isVatIncluded: isVatIncludedValue ? TF.TRUE : TF.FALSE,
          })
        );
        this.loading = false;
        this.isSubmitLoading = false;

        if (
          this.createProfile.controls['oldpassword'].touched &&
          this.createProfile.controls['newpassword'].touched
        ) {
          const user = await Auth.currentAuthenticatedUser();
          Auth.changePassword(
            user,
            this.createProfile.controls['oldpassword'].value,
            this.createProfile.controls['newpassword'].value
          )
            .then((res) => {
              this.createProfile.controls['oldpassword'].setValue('');
              this.createProfile.controls['confirm'].setValue('');
              this.createProfile.controls['newpassword'].setValue('');
              this.errorMessage = '';

              this.snackbar.open('Changes successfully saved', '', {
                duration: 5000,
                panelClass: ['white-snackbar'],
              });
            })
            .catch((err) => {
              if (err.message.includes('Incorrect username or password.')) {
                this.errorMessage = 'Error, incorrect password!';
              } else if (
                err.message.includes(
                  'Attempt limit exceeded, please try after some time.'
                )
              ) {
                this.errorMessage =
                  'Attempt limit exceeded, please try after some time.';
              }
            });
        } else {
          this.snackbar.open('Changes successfully saved', '', {
            duration: 5000,
            panelClass: ['white-snackbar'],
          });
        }
        this.createProfile.controls['oldpassword'].markAsPristine();
        this.createProfile.controls['newpassword'].markAsPristine();
        this.createProfile.controls['confirm'].markAsPristine();
      })
      .catch((err) => {
        this.loading = false;
        this.isSubmitLoading = false;
      });
  }

  hasMismatchError(): boolean {
    return this.createProfile.hasError('mismatch');
  }

  getLabelStyle(): any {
    return false;
  }

  setUsernameToReadOnlyFalse() {
    this.isUsernameReadOnly = false;
  }

  get isFormDisabled(): boolean {
    if (
      this.createProfile.invalid ||
      this.createProfile.pristine ||
      this.formSubmitted
    ) {
      return true;
    }
    // if (
    //   this.createProfile.get('vatIncluded')?.touched &&
    //   this.createProfile.get('vatIncluded')?.value ===
    //     this.originalVatIncludedValue
    // ) {
    const currentFormValue = this.createProfile.value;
    const isFormChanged = !this.isEqual(
      currentFormValue,
      this.originalFormValue
    );
    //   this.isButtonValid = true;
    return !isFormChanged;
    // }

    // return false;
  }
  private isEqual(obj1: any, obj2: any): boolean {
    obj1.phone = parseInt(obj1.phone);
    obj2.phone = parseInt(obj2.phone);
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }

  onVatIncludedToggle() {
    this.formSubmitted = false;
  }

  onInputChange(event: any) {
    let phoneValue = this.createProfile.get('phone')?.value;
    phoneValue = phoneValue.replace(/[^0-9]/g, '');
    this.createProfile.get('phone')?.setValue(phoneValue);
  }

  onNameChange(event: any) {
    const nameValue = this.createProfile.get('firstName')?.value;
    if (/[^a-zA-Z]/.test(nameValue)) {
      const newStr = nameValue.replace(/[^a-zA-Z]/g, '');
      this.createProfile.get('firstName')?.setValue(newStr);
    }
  }

  onSurnameChange(event: any) {
    const surnameValue = this.createProfile.get('lastName')?.value;
    if (/[^a-zA-Z]/.test(surnameValue)) {
      const newStr = surnameValue.replace(/[^a-zA-Z]/g, '');
      this.createProfile.get('lastName')?.setValue(newStr);
    }
  }
}
